// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__0uyVM"};